import axios from 'axios'

const API_BASE = '/wp-json/wp/v2/'

export default {
  getProjects ({ commit }) {
    return axios.get(apiUrl('project')).then(({ data }) => {
      commit('GOT_PROJECTS', data)
    })
  },
  getProject ({ commit, state }, { slug, type }) {
    // console.log('get', slug, type, state.projects)
    if (state.projects[slug]) {
      commit('SELECT_PROJECT', slug)
      return Promise.resolve()
    }
    return axios.get(apiUrl(type), { params: { slug } }).then(({ data }) => {
      if (!data.length) throw new Error('404 Not Found')
      let post = data[0]
      commit('GOT_PROJECT', post)
      commit('SELECT_PROJECT', slug)
    })
  },

  loadHomePage ({ commit, state }) {
    if (state.pages['home']) {
      commit('SELECT_PAGE', 'home')
      return Promise.resolve()
    } else {
      return Promise.reject()
    }
  },
  getPage ({ commit, state }, slug) {
    if (state.pages[slug]) {
      commit('SELECT_PAGE', slug)
      return Promise.resolve()
    }
    return axios.get(`/wp-json/ms/v1/pages/${slug}`).then(({ data }) => {
      commit('GOT_PAGE', data)
    })
  },

  getPosts ({ commit, state }) {
    if (state.posts.length) {
      return Promise.resolve()
    }
    return axios.get(apiUrl('posts'), {
      params: { per_page: 100 }
    }).then(({ data }) => {
      commit('GOT_POSTS', data)
    })
  }
}

function apiUrl (endpoint) {
  return API_BASE + endpoint
}



// WEBPACK FOOTER //
// ./src/store/actions.js